<template>
	<v-simple-table class="table-scrollable">
		<template v-slot:default>
			<thead>
				<tr>
					<th class="text-left p-1" width="70%">Change Request</th>
					<th class="text-left p-1">Created</th>
					<th class="text-left p-1">User</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(log,index) in logs" :key="index" class="align-top">
					<td class="p-1 pt-4"><span style="white-space: pre-wrap">{{ log.logs }}</span></td>
					<td class="p-1 pt-4">{{ log.created_at }}</td>
					<td class="p-1 pt-4">
						{{ log.updated_by }}
					</td>
				</tr>
			</tbody>

		</template>
	</v-simple-table>
</template>


<script>
import moment from 'moment'

export default {

    props: {
        notes : { type: Array }
    },

	computed: {
		logs() {
			let logs = this.notes.map(key => {
				key.created_at = moment(key.created_at).format('YYYY-MM-DD HH:mm')
				return key
			})

			return logs
		}
	},
}

</script>